import { useNewTranslations } from '@/common/translations';

export default function NoGamesInfo() {
  const translate = useNewTranslations();

  const subTextClassName =
    'text-center font-robotoRegular font-normal text-[12px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark';

  return (
    <div className="flex flex-col mt-[56px] mb-[54px] px-2 pb-2">
      <h3 className="text-center font-unibet font-medium text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
        {translate('PreMatchStats.NoRecentMatchesYet')}
      </h3>
      <span className={`mt-2 ${subTextClassName}`}>
        {translate('PreMatchStats.NoRecentMatchesYetDetails')}
      </span>
      <span className={`mt-4 ${subTextClassName}`}>
        {translate('PreMatchStats.CheckafterFirstMatches')}
      </span>
    </div>
  );
}
